import api from './client'

export const facturasApi = {
  listar: (params = {}) => api.get('/facturas', { params }),
}
